import BulkActions from './BulkActions';

export { default as DeleteArchiveConfigAction } from './DeleteArchiveConfigAction';

export default BulkActions;
